import React from 'react';

export const vuHQLink = () => {
    return (
        <a className="txt-link" href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres" target="_blank">
        VUHQ
        </a>
    )
}

export const getFinancialContentErrorMessage = () => {
  return (
    <div className="question-group question-group-divider">
        <div className="financial-info">
            <p>
                Sorry, we're unable to load the financial support information at the moment. Please try again later or contact {' '} 
                {vuHQLink()}
                {' '} if the issue persists.
            </p>
        </div>
    </div>
  );
};